const Styles = {
    'PopoverHeading': 'PopoverHeading_PopoverHeading--668f4ed1',
    'locationName': 'PopoverHeading_locationName--71d656ed'
};

export default Styles;